import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  info: {
    margin: 0
  },
  title: {
    padding: theme.spacing(2, 0)
  },
  bold: {
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  noSpacing: {
    padding: 0,
    margin: 0
  }
}));